(function(){
  function enhanceProduct(){
    if(!document.body.classList.contains('template-product') && !location.pathname.includes('/products/')) return;
    const form=document.querySelector('form[action*="/cart/add"]');
    if(!form || form.dataset.vkEnhanced) return;
    form.dataset.vkEnhanced='true';
    const submit=form.querySelector('button[type="submit"], input[type="submit"]');
    if(!submit) return;
    const note=document.createElement('div');
    note.className='vk-bulk-note';
    note.innerHTML='🎉 <strong>Koop 2 of meer en ontvang 10% korting</strong> met code <strong>MEER10</strong>.';
    submit.parentNode.insertBefore(note,submit);
    const trust=document.createElement('div');
    trust.className='vk-security-row';
    trust.innerHTML='<span>🔒 Veilig betalen</span><span>★ Premium kwaliteit</span><span>♥ Klant is koning</span>';
    submit.parentNode.insertBefore(trust,submit.nextSibling);
    const sticky=document.createElement('div'); sticky.className='vk-sticky-buy';
    const price=document.querySelector('[data-product-price], .price, product-price');
    sticky.innerHTML='<span class="vk-sticky-buy__price">'+(price?price.textContent.trim().slice(0,20):'')+'</span><button type="button">Nu bestellen</button>';
    sticky.querySelector('button').addEventListener('click',()=>{submit.scrollIntoView({behavior:'smooth',block:'center'}); setTimeout(()=>submit.focus({preventScroll:true}),450)});
    document.body.appendChild(sticky);
  }
  document.addEventListener('DOMContentLoaded',enhanceProduct);
  document.addEventListener('shopify:section:load',enhanceProduct);
  setTimeout(enhanceProduct,1200);
})();
